import { Button, Typography } from "antd";

import AgencyApplyButtonStyle from '../../styles/AgencyApplyButton.module.css'

const { Link, Text, Title } = Typography

const AgencyApplyButton = ({ link }) => {
    return ( 
        <a className={AgencyApplyButtonStyle['agency-apply-button']} href={link}>
          <Text className={AgencyApplyButtonStyle['agency-apply-button-text']}>Click Here to Apply!</Text>
          <img src="https://assets.cure.com/img/main-site/Roundy Click Image.jpg" className={AgencyApplyButtonStyle['roundy-image']} alt="Roundy" />
        </a>
     );
}
 
export default AgencyApplyButton;